"use strict";

var _interopRequireWildcard = require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;

var _interopRequireDefault = require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime.js");

var _defineProperty2 = _interopRequireDefault(require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/esm/defineProperty.js"));

var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));

var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js"));

require("core-js/modules/es.number.constructor.js");

require("core-js/modules/es.json.stringify.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.regexp.to-string.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.function.name.js");

var _commonMixin = _interopRequireDefault(require("@/components/common/commonMixin.vue"));

var _order = require("@/model/exchange/order.js");

var _NoData = _interopRequireDefault(require("@/components/common/NoData"));

var _index = require("@/utils/index.js");

var _vuex = require("vuex");

var _message = require("@/components/dialog/message.js");

var Account = _interopRequireWildcard(require("@/model/user/account"));

var _settings = require("@/model/settings");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = (0, _defineProperty2.default)({
  props: {
    marketList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    exchangeCoinMap: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    swap_symbol_id: {
      type: [String, Number],
      default: function _default() {
        return 22;
      }
    },
    from_symbol: {
      type: [String, Number]
    },
    to_symbol: {
      type: [String, Number]
    }
  },
  mixins: [_commonMixin.default],
  components: {
    NoData: _NoData.default
  },
  data: function data() {
    return {
      parseTime: _index.parseTime,
      ws: null,
      tableData: [],
      tableDataComputed: [],
      orderLoading: true,
      dialogVisible: false,
      hidenCancelChecked: false,
      checked: false,
      layout: "total, prev, pager, next",
      symbolId: "",
      trust_id: "",
      orderNum: 0,
      pageInfo: {
        pageCount: 1,
        pageCurrent: 1,
        pageSize: 6,
        pageTotal: 6
      },
      tabList: [{
        value: "1",
        label: "当前委托"
      }, {
        value: "2",
        label: "历史委托"
      } // {
      //   value: "3",
      //   label: "成交明细",
      // },
      ],
      currIndex: "1",
      coinItemIdMap: {},
      tradeMap: {
        1: this.translateTitle("市价"),
        2: this.translateTitle("限价")
      },
      sideMap: {
        buy: this.translateTitle("买入"),
        sell: this.translateTitle("卖出")
      },
      statusMap: {
        0: this.translateTitle("未成交"),
        1: this.translateTitle("部分成交"),
        2: this.translateTitle("完全成交"),
        3: this.translateTitle("已撤销")
      }
    };
  },
  created: function created() {
    var _this = this;

    return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _yield$Account$getUse, userInfo;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.getExchangeItemId();

            case 2:
              _context.next = 4;
              return Account.getUserInfo();

            case 4:
              _yield$Account$getUse = _context.sent;
              userInfo = _yield$Account$getUse.userInfo;

              if (userInfo) {
                _this.startTimer();
              }

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  mounted: function mounted() {},
  computed: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, (0, _vuex.mapGetters)({
    userInfo: "user/userInfo",
    language: "user/language"
  })), {}, {
    tableHeight: function tableHeight() {
      var tempHeight = 300;
      tempHeight = this.currIndex == 1 ? 360 : 300;
      return tempHeight;
    }
  }),
  methods: {
    onOK: function onOK() {
      this.onCancelOrder();
      this.dialogVisible = false;
    },
    onOpenConfirm: function onOpenConfirm(id) {
      this.trust_id = id;
      this.dialogVisible = true;
    },
    getExchangeItemId: function getExchangeItemId() {
      var _this2 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _yield$apiGetStaticTa, status, data;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return (0, _settings.apiGetStaticTableInfo)(13);

              case 2:
                _yield$apiGetStaticTa = _context2.sent;
                status = _yield$apiGetStaticTa.status;
                data = _yield$apiGetStaticTa.data;

                if (status == 200) {
                  _this2.coinItemIdMap = JSON.parse(JSON.stringify(data));
                }

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    reset: function reset(type) {
      this.orderLoading = true;
      this.currIndex = type.toString();
      this.pageInfo.pageCurrent = 1;
      this.initData(this.checked);
    },
    onSymbolChange: function onSymbolChange(item) {
      this.$emit("on-symbol-change", item);
    },
    onSymbolClick: function onSymbolClick(row) {
      var params = {
        symbol_id: row.symbol_id,
        info: {
          coin_from: row.coin_from,
          coin_to: row.coin_to,
          name: row.symbol_name_v2
        }
      };
      this.$emit("on-symbol-change", params);
    },
    startTimer: function startTimer() {
      var _this3 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var timer;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                timer = setTimeout(function () {
                  _this3.initData(_this3.checked);

                  _this3.startTimer();
                }, 3000);

                _this3.$once("hook:beforeDestroy", function () {
                  clearTimeout(timer);
                });

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    onCancelOrder: function onCancelOrder() {
      var _this4 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var req, _yield$apiTrustCancel, status, data;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                req = {
                  trust_id: _this4.trust_id
                };
                _context4.next = 3;
                return (0, _order.apiTrustCancel)(req);

              case 3:
                _yield$apiTrustCancel = _context4.sent;
                status = _yield$apiTrustCancel.status;
                data = _yield$apiTrustCancel.data;

                if (status == 200) {
                  (0, _message.showMessage)({
                    message: _this4.translateTitle("撤销成功"),
                    type: "success"
                  });

                  _this4.initData(_this4.checked);
                }

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    onAreaChange: function onAreaChange(item) {
      this.orderLoading = true;
      this.tableData = [];
      this.currIndex = item.value;
      this.pageInfo.pageCurrent = 1;
      this.initData(this.checked);
    },
    initData: function initData() {
      var _arguments = arguments,
          _this5 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var checked, _yield$Account$getUse2, userInfo, tempStatus, temp_symbol_id, req, temp_order_status, _req;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                checked = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : false;

                if (_this5.swap_symbol_id) {
                  _context5.next = 4;
                  break;
                }

                _this5.orderLoading = false;
                return _context5.abrupt("return");

              case 4:
                _context5.next = 6;
                return Account.getUserInfo();

              case 6:
                _yield$Account$getUse2 = _context5.sent;
                userInfo = _yield$Account$getUse2.userInfo;

                if (userInfo) {
                  _context5.next = 11;
                  break;
                }

                _this5.orderLoading = false;
                return _context5.abrupt("return");

              case 11:
                tempStatus = _this5.currIndex;

                if (_this5.currIndex == 3) {
                  tempStatus = "";
                }

                temp_symbol_id = _this5.swap_symbol_id;

                if (checked) {
                  temp_symbol_id = _this5.swap_symbol_id;
                } else {
                  temp_symbol_id = "";
                }

                if (!(_this5.currIndex == 1)) {
                  _context5.next = 20;
                  break;
                }

                req = {
                  symbol_id: temp_symbol_id
                };
                return _context5.abrupt("return", (0, _order.apiTrustIndex)(req).then(function (res) {
                  if (res.status == 200 && res.data.length > 0) {
                    _this5.orderNum = res.data.length;

                    var _loop = function _loop(key) {
                      res.data.forEach(function (ele) {
                        if (ele.symbol_id == key) {
                          ele.symbol_name_v2 = _this5.exchangeCoinMap[key].name.toUpperCase();
                        }
                      });
                    };

                    for (var key in _this5.exchangeCoinMap) {
                      _loop(key);
                    }

                    var _loop2 = function _loop2(_key) {
                      res.data.forEach(function (ele) {
                        if (ele.coin_from == _key) {
                          ele.coin_name = _this5.coinItemIdMap[_key].item_name.toUpperCase();
                        }

                        if (ele.coin_to == _key) {
                          ele.coin_to_name = _this5.coinItemIdMap[_key].item_name.toUpperCase();
                        }
                      });
                    };

                    for (var _key in _this5.coinItemIdMap) {
                      _loop2(_key);
                    }

                    _this5.tableData = res.data;
                  } else {
                    _this5.tableData = [];
                    _this5.orderNum = 0;
                    _this5.orderLoading = false;
                  }

                  _this5.orderLoading = false;
                }));

              case 20:
                if (!(_this5.currIndex == 2)) {
                  _context5.next = 25;
                  break;
                }

                temp_order_status = "1,2,3";

                if (_this5.hidenCancelChecked) {
                  temp_order_status = "1,2";
                } else {
                  temp_order_status = "1,2,3";
                }

                _req = {
                  symbol_id: temp_symbol_id,
                  status: temp_order_status,
                  page: _this5.pageInfo.pageCurrent,
                  page_size: _this5.pageInfo.pageSize
                };
                return _context5.abrupt("return", (0, _order.apiTrustDealIndex)(_req).then(function (res) {
                  if (res.status == 200) {
                    var _loop3 = function _loop3(key) {
                      res.data.list.forEach(function (ele) {
                        if (ele.symbol_id == key) {
                          ele.symbol_name_v2 = _this5.exchangeCoinMap[key].name.toUpperCase();
                        }
                      });
                    };

                    for (var key in _this5.exchangeCoinMap) {
                      _loop3(key);
                    }

                    var _loop4 = function _loop4(_key2) {
                      res.data.list.forEach(function (ele) {
                        if (ele.fee_item_id == _key2) {
                          ele.fee_item_name = _this5.coinItemIdMap[_key2].item_name.toUpperCase();
                        }

                        if (ele.coin_from == _key2) {
                          ele.coin_name = _this5.coinItemIdMap[_key2].item_name.toUpperCase();
                        }

                        if (ele.coin_to == _key2) {
                          ele.coin_to_name = _this5.coinItemIdMap[_key2].item_name.toUpperCase();
                        }
                      });
                    };

                    for (var _key2 in _this5.coinItemIdMap) {
                      _loop4(_key2);
                    }

                    _this5.tableData = res.data.list;
                    _this5.pageInfo = res.data.pageInfo;
                  } else {
                    _this5.orderLoading = false;
                  }

                  _this5.orderLoading = false;
                }));

              case 25:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    onCurrentPageChange: function onCurrentPageChange() {
      this.orderLoading = true;
      this.initData(this.checked);
    }
  },
  watch: {
    language: function language() {
      this.tradeMap = {
        1: this.translateTitle("市价"),
        2: this.translateTitle("限价")
      };
      this.sideMap = {
        buy: this.translateTitle("买入"),
        sell: this.translateTitle("卖出")
      };
      this.statusMap = {
        0: this.translateTitle("未成交"),
        1: this.translateTitle("待成交"),
        2: this.translateTitle("完全成交"),
        3: this.translateTitle("已撤销")
      };
    },
    swap_symbol_id: {
      handler: function handler(newVal, oldVal) {
        if (oldVal == undefined) {
          return;
        }

        if (newVal != oldVal) {
          this.symbolId = newVal;
          this.orderLoading = true;
          this.pageInfo.pageCurrent = 1;
          this.initData(this.checked);
        }
      }
    },
    hidenCancelChecked: function hidenCancelChecked() {
      this.initData(this.checked);
    },
    checked: function checked() {
      this.initData(this.checked);
    }
  }
}, "computed", {// showList() {
  //   return this.marketList;
  // },
});

exports.default = _default2;